import { render } from "./WorkflowDetails.vue?vue&type=template&id=2bd7b3fe&scoped=true"
import script from "./WorkflowDetails.vue?vue&type=script&lang=js"
export * from "./WorkflowDetails.vue?vue&type=script&lang=js"

import "./WorkflowDetails.vue?vue&type=style&index=0&id=2bd7b3fe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd7b3fe"]])

export default __exports__